import { Component, inject } from '@angular/core';
import { NgClass } from '@angular/common';
import { MatListItem, MatNavList } from '@angular/material/list';
import { Router, RouterLink } from '@angular/router';
import { TranslocoDirective } from '@jsverse/transloco';
import { LayoutService } from '@processpuzzle/util';
import { navigableRoutes } from '../current-application';

/**
 * The workspace's navigation list: the application itself, then whatever `ORG_ADMIN_ROUTES` contributes.
 *
 * Reads `router.config` for the same reason the header does — the routes are built at bootstrap
 * from the organization the URL named, so there is no constant to import.
 *
 * Nothing is rendered on a handset: at that width the header moves the same routes into a menu.
 */
@Component({
  selector: 'app-sidenav',
  imports: [MatListItem, MatNavList, NgClass, RouterLink, TranslocoDirective],
  template: `
    @if (!layoutService.isSmallDevice()) {
      <ng-container *transloco="let t; prefix: 'navigation'">
        <mat-nav-list>
          @for (item of routes; track item.path) {
            <mat-list-item [routerLink]="'/' + item.path" [ngClass]="layoutService.layoutClass()">
              <span matListItemIcon class="material-symbols-outlined">{{ item.data?.['icon'] }}</span>
              <div matListItemTitle>&nbsp;{{ t(item.data?.['menuTitle']) }}</div>
            </mat-list-item>
          }
        </mat-nav-list>
      </ng-container>
    }
  `,
  styleUrl: 'sidenav.component.scss',
})
export class SidenavComponent {
  readonly layoutService = inject(LayoutService);
  private readonly router = inject(Router);
  readonly routes = navigableRoutes(this.router.config);
}
